/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { Configuration } from '../configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { apiAgentsAgentIdTestsGet } from '../fn/tests/api-agents-agent-id-tests-get';
import { ApiAgentsAgentIdTestsGet$Params } from '../fn/tests/api-agents-agent-id-tests-get';
import { apiAgentsAgentIdTestsPost } from '../fn/tests/api-agents-agent-id-tests-post';
import { ApiAgentsAgentIdTestsPost$Params } from '../fn/tests/api-agents-agent-id-tests-post';
import { apiTestRunsGet } from '../fn/tests/api-test-runs-get';
import { ApiTestRunsGet$Params } from '../fn/tests/api-test-runs-get';
import { apiTestRunsIdGet } from '../fn/tests/api-test-runs-id-get';
import { ApiTestRunsIdGet$Params } from '../fn/tests/api-test-runs-id-get';
import { apiTestRunsPost } from '../fn/tests/api-test-runs-post';
import { ApiTestRunsPost$Params } from '../fn/tests/api-test-runs-post';
import { apiTestsGet } from '../fn/tests/api-tests-get';
import { ApiTestsGet$Params } from '../fn/tests/api-tests-get';
import { apiTestsIdDelete } from '../fn/tests/api-tests-id-delete';
import { ApiTestsIdDelete$Params } from '../fn/tests/api-tests-id-delete';
import { apiTestsIdGet } from '../fn/tests/api-tests-id-get';
import { ApiTestsIdGet$Params } from '../fn/tests/api-tests-id-get';
import { apiTestsPost } from '../fn/tests/api-tests-post';
import { ApiTestsPost$Params } from '../fn/tests/api-tests-post';
import { apiTestsPut } from '../fn/tests/api-tests-put';
import { ApiTestsPut$Params } from '../fn/tests/api-tests-put';
import { CreateResult } from '../models/create-result';
import { GetAgentTestsResult } from '../models/get-agent-tests-result';
import { GetTestRunsResult } from '../models/get-test-runs-result';
import { GetTestsResult } from '../models/get-tests-result';
import { RunTestsResult } from '../models/run-tests-result';
import { TestDto } from '../models/test-dto';
import { TestRunDto } from '../models/test-run-dto';


/**
 * Agent evaluation tests (Simulation / NextReply / ToolInvocation). Currently
 * only Simulation is fully wired through to the LiveKit worker — the other
 * two types are reserved for future expansion.
 */
@Injectable({ providedIn: 'root' })
export class TestsService extends BaseService {
  constructor(config: Configuration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `apiTestsGet()` */
  static readonly ApiTestsGetPath = '/api/Tests';

  /**
   * List tests in the current space. Optional filter by test type.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiTestsGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiTestsGet$Response(params?: ApiTestsGet$Params, context?: HttpContext): Observable<StrictHttpResponse<GetTestsResult>> {
    const obs = apiTestsGet(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * List tests in the current space. Optional filter by test type.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiTestsGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiTestsGet(params?: ApiTestsGet$Params, context?: HttpContext): Observable<GetTestsResult> {
    const resp = this.apiTestsGet$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<GetTestsResult>): GetTestsResult => r.body)
    );
  }

  /** Path part for operation `apiTestsPut()` */
  static readonly ApiTestsPutPath = '/api/Tests';

  /**
   * Update an existing test by id.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiTestsPut()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiTestsPut$Response(params?: ApiTestsPut$Params, context?: HttpContext): Observable<StrictHttpResponse<CreateResult>> {
    const obs = apiTestsPut(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Update an existing test by id.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiTestsPut$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiTestsPut(params?: ApiTestsPut$Params, context?: HttpContext): Observable<CreateResult> {
    const resp = this.apiTestsPut$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<CreateResult>): CreateResult => r.body)
    );
  }

  /** Path part for operation `apiTestsPost()` */
  static readonly ApiTestsPostPath = '/api/Tests';

  /**
   * Create a new test. Simulation-type fields are validated via FluentValidation.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiTestsPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiTestsPost$Response(params?: ApiTestsPost$Params, context?: HttpContext): Observable<StrictHttpResponse<CreateResult>> {
    const obs = apiTestsPost(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Create a new test. Simulation-type fields are validated via FluentValidation.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiTestsPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiTestsPost(params?: ApiTestsPost$Params, context?: HttpContext): Observable<CreateResult> {
    const resp = this.apiTestsPost$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<CreateResult>): CreateResult => r.body)
    );
  }

  /** Path part for operation `apiTestsIdGet()` */
  static readonly ApiTestsIdGetPath = '/api/Tests/{id}';

  /**
   * Get full test details by id.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiTestsIdGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiTestsIdGet$Response(params: ApiTestsIdGet$Params, context?: HttpContext): Observable<StrictHttpResponse<TestDto>> {
    const obs = apiTestsIdGet(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get full test details by id.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiTestsIdGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiTestsIdGet(params: ApiTestsIdGet$Params, context?: HttpContext): Observable<TestDto> {
    const resp = this.apiTestsIdGet$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<TestDto>): TestDto => r.body)
    );
  }

  /** Path part for operation `apiTestsIdDelete()` */
  static readonly ApiTestsIdDeletePath = '/api/Tests/{id}';

  /**
   * Soft-delete a test and detach it from all agents.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiTestsIdDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiTestsIdDelete$Response(params: ApiTestsIdDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = apiTestsIdDelete(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Soft-delete a test and detach it from all agents.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiTestsIdDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiTestsIdDelete(params: ApiTestsIdDelete$Params, context?: HttpContext): Observable<void> {
    const resp = this.apiTestsIdDelete$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiAgentsAgentIdTestsGet()` */
  static readonly ApiAgentsAgentIdTestsGetPath = '/api/agents/{agentId}/tests';

  /**
   * List tests attached to an agent. Returns thin AgentTest links
   * (Id, AgentId, TestId, CreatedAt); the client fetches the test details
   * separately via M:AspNetBackend.API.Controllers.TestsController.GetTests(System.Nullable{AspNetBackend.Domain.Enums.TestType}) or M:AspNetBackend.API.Controllers.TestsController.GetTest(System.Guid).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiAgentsAgentIdTestsGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiAgentsAgentIdTestsGet$Response(params: ApiAgentsAgentIdTestsGet$Params, context?: HttpContext): Observable<StrictHttpResponse<GetAgentTestsResult>> {
    const obs = apiAgentsAgentIdTestsGet(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * List tests attached to an agent. Returns thin AgentTest links
   * (Id, AgentId, TestId, CreatedAt); the client fetches the test details
   * separately via M:AspNetBackend.API.Controllers.TestsController.GetTests(System.Nullable{AspNetBackend.Domain.Enums.TestType}) or M:AspNetBackend.API.Controllers.TestsController.GetTest(System.Guid).
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiAgentsAgentIdTestsGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiAgentsAgentIdTestsGet(params: ApiAgentsAgentIdTestsGet$Params, context?: HttpContext): Observable<GetAgentTestsResult> {
    const resp = this.apiAgentsAgentIdTestsGet$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<GetAgentTestsResult>): GetAgentTestsResult => r.body)
    );
  }

  /** Path part for operation `apiAgentsAgentIdTestsPost()` */
  static readonly ApiAgentsAgentIdTestsPostPath = '/api/agents/{agentId}/tests';

  /**
   * Attach a set of tests to an agent. Duplicates in the list are allowed
   * by design — each entry becomes its own attachment row.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiAgentsAgentIdTestsPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiAgentsAgentIdTestsPost$Response(params: ApiAgentsAgentIdTestsPost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = apiAgentsAgentIdTestsPost(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Attach a set of tests to an agent. Duplicates in the list are allowed
   * by design — each entry becomes its own attachment row.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiAgentsAgentIdTestsPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiAgentsAgentIdTestsPost(params: ApiAgentsAgentIdTestsPost$Params, context?: HttpContext): Observable<void> {
    const resp = this.apiAgentsAgentIdTestsPost$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiTestRunsGet()` */
  static readonly ApiTestRunsGetPath = '/api/test-runs';

  /**
   * List test runs for a given agent, cursor-paginated. Each item carries
   * aggregate counters over its child sessions (Total/Success/Failed/Processing).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiTestRunsGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiTestRunsGet$Response(params?: ApiTestRunsGet$Params, context?: HttpContext): Observable<StrictHttpResponse<GetTestRunsResult>> {
    const obs = apiTestRunsGet(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * List test runs for a given agent, cursor-paginated. Each item carries
   * aggregate counters over its child sessions (Total/Success/Failed/Processing).
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiTestRunsGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiTestRunsGet(params?: ApiTestRunsGet$Params, context?: HttpContext): Observable<GetTestRunsResult> {
    const resp = this.apiTestRunsGet$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<GetTestRunsResult>): GetTestRunsResult => r.body)
    );
  }

  /** Path part for operation `apiTestRunsPost()` */
  static readonly ApiTestRunsPostPath = '/api/test-runs';

  /**
   * Kick off a batch run: creates a TestRun and one AgentSession per test
   * via the standard DispatchAgentCommand (real LiveKit room + worker
   * dispatch). Capped at 10 tests per call.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiTestRunsPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiTestRunsPost$Response(params?: ApiTestRunsPost$Params, context?: HttpContext): Observable<StrictHttpResponse<RunTestsResult>> {
    const obs = apiTestRunsPost(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Kick off a batch run: creates a TestRun and one AgentSession per test
   * via the standard DispatchAgentCommand (real LiveKit room + worker
   * dispatch). Capped at 10 tests per call.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiTestRunsPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiTestRunsPost(params?: ApiTestRunsPost$Params, context?: HttpContext): Observable<RunTestsResult> {
    const resp = this.apiTestRunsPost$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<RunTestsResult>): RunTestsResult => r.body)
    );
  }

  /** Path part for operation `apiTestRunsIdGet()` */
  static readonly ApiTestRunsIdGetPath = '/api/test-runs/{id}';

  /**
   * Get a single test run with the inline list of its test sessions
   * (AspNetBackend.Application.TestRuns.Models.TestRunSessionDto).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiTestRunsIdGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiTestRunsIdGet$Response(params: ApiTestRunsIdGet$Params, context?: HttpContext): Observable<StrictHttpResponse<TestRunDto>> {
    const obs = apiTestRunsIdGet(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get a single test run with the inline list of its test sessions
   * (AspNetBackend.Application.TestRuns.Models.TestRunSessionDto).
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiTestRunsIdGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiTestRunsIdGet(params: ApiTestRunsIdGet$Params, context?: HttpContext): Observable<TestRunDto> {
    const resp = this.apiTestRunsIdGet$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<TestRunDto>): TestRunDto => r.body)
    );
  }

}
